import { PurchaseSuccess as PurchaseSuccessComponent } from '@components/PurchaseSuccess';

export const PurchaseSuccess = () => <PurchaseSuccessComponent />;
